//#region imports
import React, { useMemo, useEffect } from 'react';

// custom components
import FlightInformation from '../flight-information';
import JobList from './job-list';
import AltPickupList from './alt-pickup-list';
import GateRelocationList from './gate-relocation-list';
import RampTask from './ramp-task';
import MarshallTask from './marshall-task';

// redux
import { useSelector } from 'react-redux';
import { selectFlightById } from '_redux/slices/timeline/timeline-flight-list';
import { selectRampBookings, selectMarshallTask, selectPreBoard } from '_redux/slices/timeline/timeline-control';
import { selectAllBookingsByFlight } from '_redux/slices/timeline/timeline-bookings';
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';
//#endregion

const FlightRow = ({ flightKey, handleGetBookings }) => {

  // check props
  if (!flightKey) return null;

  //#region redux
  // PERFORMANCE FIX: Memoize selectors to prevent recreation on every render
  const flightSelector = useMemo(() => selectFlightById(flightKey), [flightKey]);
  const flight = useSelector(flightSelector);

  const rampBookings = useSelector(selectRampBookings);                               // ramp booking switch, hide if false
  const marshallTask = useSelector(selectMarshallTask);                               // marshall task switch, hide if false
  const preBoard = useSelector(selectPreBoard);                                       // preboard switch

  const bookingsSelector = useMemo(() => selectAllBookingsByFlight(flightKey), [flightKey]);
  const allBookings = useSelector(bookingsSelector);

  const dbUser = useSelector(selectFirebaseInfo);
  const isJersey = dbUser?.details?.authority === 'JER';
  //#endregion

  // if no flight found, return null
  if (!flight) return null;

  // check if boarding flight
  const isBoardingFlight = flight?.type === 'boarding' || flight?.isBoardingFlight;

  // check if ramp task
  const isRampTask = flight?.type === 'ramp' || flight?.isRampTask;

  // check if marshall task
  const isMarshallTask = (isRampTask || isBoardingFlight) && marshallTask;   // show marshall tasks for ramp flights

  // check departure (only show alt pickups for departures)
  const isDeparture = flight?.type === 'departure';

  // check if in past
  const isInPast = flight?.inPast;

  return (
    <div
      onClick={() => {
        //console.log('clicked flight row', flightKey);
      }}
      style={{
        marginBottom: '2px',
        flex: 1,
        opacity: isInPast ? 0.5 : 1,
        position: 'relative',  // Required for z-index to work
        zIndex: 253  // appear on top of red line
      }}>

      {/* gate relocation flight list - show under boarding if preboard on, otherwise under departures 
      {(preBoard ? isBoardingFlight : isDeparture) &&
        <GateRelocationList
          flightKey={flightKey}
          flight={flight}
        />
      }
      */}

      {/* flight card */}
      <FlightInformation
        flight={flightKey}
        flightKey={flightKey}
        flightData={flight}
        boarding={isBoardingFlight}
        handleGetBookings={handleGetBookings}
      />

      {/* show ramp task for ramp flight + ramp switch on */}
      {isRampTask && rampBookings &&
        <RampTask
          flightKey={flightKey}
          flightData={flight}
        />
      }

      {/* show marshall task for marshall flight + marshall switch on */}
      {isMarshallTask && marshallTask &&
        <MarshallTask
          flightKey={flightKey}
          flightData={flight}
          type={flight?.type === 'departure' || flight?.type === 'boarding' ? "departure" : "arrival"}
          paxList={isBoardingFlight && Array.isFullArray(allBookings?.[0]?.passengers) ? allBookings?.[0]?.passengers : []}
        />
      }

      {/* job list */}
      <JobList
        isBoardingFlight={isBoardingFlight}
        flightKey={flightKey}
        flightData={flight}
        showFullCard={true}
      />

      {/* alt pickup flight list - only for Jersey */}
      {isDeparture && isJersey &&
        <AltPickupList
          flightKey={flightKey}
          flight={flight}
        />
      }



    </div>
  );
};

export default React.memo(FlightRow, (prevProps, nextProps) => {
  // only re-render if the flightKey changes
  return prevProps.flightKey === nextProps.flightKey;
});

